import ActionButton from "components/common/ActionButton";
import { useFetchRx } from "hooks/useFetchRx";
import useQuery from "hooks/useQuery";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  FloatingLabel,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import useDetectKeyboardLanguage from "utils/useDetectKeyboardLanguage";

const MedicationBasicInformation = () => {
  const {
    register,
    watch,
    control,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  let instructionWatch = watch("name");
  const layout = useDetectKeyboardLanguage(instructionWatch);

  const {
    fields: prescriptions,
    append: appendPrescriptions,
    remove: removePrescriptions,
    move,
  } = useFieldArray({
    control,
    name: "prescriptions",
  });

  const getSelectStyles = (hasError) => ({
    control: (provided) => ({
      ...provided,
      borderColor: hasError ? "red" : provided.borderColor,
      boxShadow: hasError
        ? "0 0 0 0.2rem rgba(255, 0, 0, 0.25)"
        : provided.boxShadow,
      "&:hover": {
        borderColor: hasError ? "red" : provided.borderColor,
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
      padding: "7px",
    }),
    placeholder: (provided) => ({
      ...provided,
      padding: "0px 7px",
    }),
    input: (provided) => ({
      ...provided,
      color: "black",
      paddingLeft: "7px",
      paddingRight: "7px",
      minWidth: "200px",
    }),
    menu: (provided) => ({ ...provided, color: "black", zIndex: 2 }),
    menuList: (provided) => ({ ...provided, padding: 0, zIndex: 1 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  });

  const {
    data: rx,
    isLoading: isRxLoading,
    isFetching: isRxFetching,
  } = useFetchRx();

  let rxData = rx?.data?.data ?? [];

  const rxOptions = rxData?.map((item) => ({
    label: item.name,
    value: item.name,
  }));

  if (isRxLoading) {
    return <Spinner animation="border" variant="primary" />;
  }

  return (
    <Card className="mb-3">
      {/* <Card.Header as="h6" className="bg-body-tertiary">
        Basic information
      </Card.Header> */}
      <Card.Body>
        {/* <Row className="gx-2 gy-3">
          <Col md="12">
            <Form.Group>
              <FloatingLabel
                controlId="floatingInput"
                label={
                  <span>
                    Type <span style={{ color: "red" }}>*</span>
                  </span>
                }
                className=""
              >
                <Form.Control
                  type="text"
                  autoFocus
                  placeholder=""
                  autoComplete="off"
                  isInvalid={!!errors.type}
                  {...register("type")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.type?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col md="12">
            <Form.Group>
              <FloatingLabel
                controlId="floatingSelectGrid"
                label={
                  <span>
                    Rx <span style={{ color: "red" }}>*</span>
                  </span>
                }
              >
                <Form.Select
                  aria-label="rx"
                  isInvalid={!!errors.rx}
                  {...register("rx")}
                >
                  <option value="">Select</option>
                  {rxData.map((d) => (
                    <option value={d.id}>{d.name}</option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors.rx?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Col>
          <Col md="12">
            <Form.Group>
              <FloatingLabel
                controlId="floatingInput"
                label={
                  <span>
                    Instructions <span style={{ color: "red" }}>*</span>
                  </span>
                }
                className=""
              >
                <Form.Control
                  type="text"
                  style={{
                    direction: layout === "Urdu" ? "rtl" : "ltr",
                  }}
                  placeholder="name@example.com"
                  autoComplete="off"
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Col>

        </Row> */}

        <Row className="gx-2 mt-3">
          <div
            style={{
              maxHeight: `calc(100vh - 20.7rem)`,
              overflowY: "auto",
            }}
          >
            <Table style={{ borderCollapse: "separate", borderSpacing: 0 }}>
              {/* 🔹 Fixed Header */}
              <thead
                className="bg-200"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  background: "#fff",
                }}
              >
                <tr>
                  <th
                    scope="col"
                    className="fs-10 text-center"
                    // style={{ width: "140px" }}
                  >
                    #
                  </th>
                  <th scope="col" className="fs-10">
                    Medication Name
                  </th>
                  <th scope="col" className="fs-10">
                    Dosage
                  </th>
                  <th scope="col" className="fs-10">
                    Frequency
                  </th>
                  <th scope="col" className="fs-10">
                    Duration
                  </th>
                  <th scope="col" className="fs-10">
                    Instructions
                  </th>
                  <th
                    scope="col"
                    style={{ padding: "9px", width: "10px" }}
                    className="text-end"
                  >
                    <ActionButton
                      icon="plus"
                      variant="success"
                      title="Add"
                      className="px-1 py-0"
                      onClick={() => appendPrescriptions({})}
                    />
                  </th>
                </tr>
              </thead>

              {/* 🔹 Table Body */}
              <tbody>
                {prescriptions.map((item, index) => (
                  <tr key={item.id || index}>
                    <td className="text-center">{index + 1}</td>
                    <td style={{ padding: "10px" }}>
                      <Form.Group>
                        <Controller
                          name={`prescriptions[${index}].medicationName`}
                          control={control}
                          render={({ field }) => (
                            <CreatableSelect
                              {...field}
                              options={rxOptions} // Replace with real options
                              isClearable
                              tabIndex={4}
                              placeholder="Medication Name"
                              styles={getSelectStyles(
                                !!errors.prescriptions?.[index]?.medicationName
                              )}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              onChange={(selectedOption) =>
                                field.onChange(
                                  selectedOption ? selectedOption.value : ""
                                )
                              }
                              value={
                                field.value
                                  ? { label: field.value, value: field.value }
                                  : null
                              }
                            />
                          )}
                        />
                        {errors.prescriptions?.[index]?.medicationName && (
                          <div className="invalid-feedback d-block">
                            {
                              errors.prescriptions?.[index]?.medicationName
                                ?.message
                            }
                          </div>
                        )}
                      </Form.Group>
                    </td>

                    <td style={{ paddingTop: "10px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Dosage"
                        tabIndex={5}
                        isInvalid={!!errors.prescriptions?.[index]?.dosage}
                        {...register(`prescriptions[${index}].dosage`)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.prescriptions?.[index]?.dosage?.message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ paddingTop: "10px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Frequency"
                        isInvalid={!!errors.prescriptions?.[index]?.frequency}
                        {...register(`prescriptions[${index}].frequency`)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.prescriptions?.[index]?.frequency?.message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ paddingTop: "10px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Duration"
                        isInvalid={!!errors.prescriptions?.[index]?.duration}
                        {...register(`prescriptions[${index}].duration`)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.prescriptions?.[index]?.duration?.message}
                      </Form.Control.Feedback>
                    </td>
                    <td style={{ paddingTop: "10px" }}>
                      <Form.Control
                        type="text"
                        placeholder="Instructions"
                        isInvalid={
                          !!errors.prescriptions?.[index]?.instructions
                        }
                        {...register(`prescriptions[${index}].instructions`)}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.prescriptions?.[index]?.instructions?.message}
                      </Form.Control.Feedback>
                    </td>

                    <td
                      style={{ paddingLeft: "9px", maxWidth: "10px" }}
                      className="text-center"
                    >
                      <ActionButton
                        icon="trash-alt"
                        title="Delete"
                        variant="danger"
                        className="px-1 py-0"
                        onClick={() => removePrescriptions(index)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Row>

        <Row className="gx-2 gy-3 my-1">
          <Col className="d-flex justify-content-end">
            <Button
              variant="link"
              className="text-secondary fw-medium p-0 me-3"
              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Ok
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MedicationBasicInformation;
